
import { ProductModel } from '@/libs/Api';
import { CrudAction } from '@/libs/core/+state/models/crud-action';
import { CrudDataStats } from '@/libs/core/+state/models/crud-data-stats';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { createCrudQueryPayload } from '@/libs/core/+state/models/crud-query-payload';
import { CrudQueryPredicate } from '@/libs/core/+state/models/crud-query-predicate';
import { productsStore } from '@/libs/products/+state/store';
import Page from '@/Page.vue';
import { Component, Prop, Watch, Ref } from 'vue-property-decorator';
import ProductDialog from '../components/ProductDialog.vue';
import { Guid } from '@/libs/common/functions/guid';

@Component({
    components: {
        ProductDialog,
    },
})
export default class Products extends Page {
    get headers() {
        return [
            { text: this.$i18n.t('products.code'), value: 'code', align: 'left', sortable: false },
            { text: this.$i18n.t('products.name'), value: 'code', align: 'left', sortable: false },
            { text: this.$i18n.t('products.project'), value: 'project.name', align: 'left', sortable: false },
            { text: '', value: 'id', align: 'left', sortable: false },
        ];
    }
    itemsPerPage = 10;

    @Prop() tenantId!: string;
    @Ref() dialog!: ProductDialog;

    @Watch('itemsPerPage')
    itemsPerPageChanged(v: number) {
        window.localStorage.amsItemsPerPage = v.toString();
    }

    get loading(): boolean {
        return productsStore.useGetter(CrudGetter.Pending);
    }

    get categories(): ProductModel[] {
        return [...productsStore.useGetter(CrudGetter.Data)];
    }

    get totalRows(): number {
        return ({ ...productsStore.useGetter(CrudGetter.DataStats) } as CrudDataStats)?.rowCount;
    }

    mounted() {
        this.itemsPerPage = window.localStorage.amsItemsPerPage ? Number(window.localStorage.amsItemsPerPage) : 10;
        this.load();
    }

    load() {
        productsStore.dispatch(CrudAction.GetAll, this.getPayload());
    }

    getFilters(): CrudQueryPredicate[] {
        let filters: CrudQueryPredicate[] = [];
        return filters;
    }

    getPayload() {
        return createCrudQueryPayload<ProductModel>({ field: 'name', index: 1, order: 'asc' }, this.getFilters());
    }

    open(item: ProductModel) {
        this.dialog.open(item.id!);
    }

    createItemClick() {
        this.dialog.open(Guid.EmptyGuid());
    }
}
